import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { RunnerCard } from '../RunnerCard';
import * as Styled from './styles';
import SelectionAssigned from '../Entered/SelectionAssigned';
import PrizeDrawCard from '../PrizeDrawCard';
import PlayItv from '../CallToActions/PlayItv';
import Entered from '../Entered';

const Winners = ({
    title,
    eventName,
    winners,
    entry,
    didEntryWin,
    TermsLink,
    Itv7TermsLink,
    prize,
    ButtonLink
}) => {
    const clothNumber = get(entry.metaData, 'clothNumber', null);
    const name = get(entry, 'name', null);
    const metaData = get(entry, 'metaData', {});
    const jockeyName = get(metaData, 'jockeyName', null);
    const trainerName = get(metaData, 'trainerName', null);
    const silk = get(metaData, 'silk', null);

    return (
        <>
            <Styled.Title>{title} SWEEPSTAKE</Styled.Title>
            <Styled.SubHeading>{eventName} Winner</Styled.SubHeading>
            <Styled.WinnerCards>
                {winners.map(winner => (
                    <RunnerCard
                        key={winner.id}
                        clothNumber={get(winner, 'metaData.clothNumber', null)}
                        horseName={get(winner, 'name', null)}
                        jockeyName={get(winner, 'metaData.jockeyName', null)}
                        trainerName={get(winner, 'metaData.trainerName', null)}
                        silk={get(winner, 'metaData.silk', null)}
                    />
                ))}
            </Styled.WinnerCards>
            {!didEntryWin && entry && (
                <SelectionAssigned
                    title={title}
                    clothNumber={clothNumber}
                    horseName={name}
                    jockeyName={jockeyName}
                    trainerName={trainerName}
                    silk={silk}
                    excludeFromBetting
                    bettingEnabled
                />
            )}
            <PrizeDrawCard
                eventName={eventName}
                TermsLink={TermsLink}
                xLink="https://x.com/ITV7Racing"
                hadEntry
                didEntryWin={didEntryWin}
                prize={prize}
            />
            <Styled.PlayItvWrapper>
                <PlayItv
                    titleText={`Loved playing the ${title} Sweepstake?`}
                    buttonText="PLAY ITV7"
                    TermsLink={Itv7TermsLink}
                    ButtonLink={ButtonLink}
                />
            </Styled.PlayItvWrapper>
        </>
    );
};

Winners.defaultProps = {
    winners: [],
    entry: {}
};

Winners.propTypes = {
    title: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    winners: PropTypes.arrayOf(PropTypes.shape(RunnerCard.propTypes)),
    didEntryWin: PropTypes.bool.isRequired,
    entry: PropTypes.shape(Entered.entry),
    TermsLink: PropTypes.func.isRequired,
    Itv7TermsLink: PropTypes.func.isRequired,
    prize: PropTypes.string.isRequired,
    ButtonLink: PropTypes.func.isRequired
};

export default Winners;
